import { render, staticRenderFns } from "./CreateGender.vue?vue&type=template&id=51e094b4"
import script from "./CreateGender.vue?vue&type=script&lang=js"
export * from "./CreateGender.vue?vue&type=script&lang=js"
import style0 from "./CreateGender.vue?vue&type=style&index=0&id=51e094b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../and-iot-pre-checkin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports